const EMOJI_PALETTE = ['🦊', '🐼', '🐯', '🦅', '🐺', '🦁', '🐻', '🐸', '🐨', '🐰', '🦉', '🐵'];
const BACKGROUND_PALETTE = ['#FFF0F0', '#F0F4FF', '#F0FFF4', '#FFF9E6', '#F5F0FF', '#E6FFFB'];

// Deterministically picks a decorative emoji + background color for a given
// id, so the same player always renders with the same avatar.
export function avatarForId(id) {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  }
  return {
    emoji: EMOJI_PALETTE[hash % EMOJI_PALETTE.length],
    background: BACKGROUND_PALETTE[hash % BACKGROUND_PALETTE.length],
  };
}
